import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">{t('footer.about')}</h3>
            <p className="text-sm mb-4">{t('footer.description')}</p>
            <img
              src="https://static.testo.com/image/upload/c_pad,h_48,w_104/f_auto/q_auto/v1/testo/testo-be-sure-logo-claim"
              alt="Testo Logo"
              className="h-8 opacity-80"
            />
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products" className="hover:text-green-400 transition-colors">{t('nav.products')}</Link></li>
              <li><Link to="/applications" className="hover:text-green-400 transition-colors">{t('nav.applications')}</Link></li>
              <li><Link to="/solutions" className="hover:text-green-400 transition-colors">{t('nav.solutions')}</Link></li>
              <li><Link to="/about" className="hover:text-green-400 transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/contact" className="hover:text-green-400 transition-colors">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">{t('nav.contact')}</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail className="h-5 w-5 text-green-400 flex-shrink-0 mt-0.5" />
                <div className="flex flex-col">
                  <span>info@altinberg.com</span>
                  <span>info@testoglobal.com</span>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="h-5 w-5 text-green-400 flex-shrink-0 mt-0.5" />
                <span>+90 850 757 60 57</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-green-400 flex-shrink-0 mt-0.5" />
                <span>İstinye, Kerametli Sk. No:3, 34460 Sarıyer/İstanbul</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} {t('footer.copy')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;